import ReactPaginate from 'react-paginate';
import classnames from 'classnames';
import { useWindowSize } from '@/hooks/useWindowSize';
import IconPrev from './icon_prev.svg?react';
import IconNext from './icon_next.svg?react';
import s from './index.module.scss';

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  className,
}) => {
  const { innerWidth } = useWindowSize();

  if (totalPages < 2) return null;

  return (
    <div className={classnames(s.wrapper, className)}>
      <ReactPaginate
        breakLabel="..."
        previousLabel={
          <button className={s.page} type="button" disabled={currentPage <= 0}>
            <IconPrev />
          </button>
        }
        nextLabel={
          <button
            className={s.page}
            type="button"
            disabled={currentPage >= totalPages}
          >
            <IconNext />
          </button>
        }
        pageClassName={s.page}
        containerClassName={s.container}
        activeClassName={s.active}
        disabledClassName={s.disabled}
        breakClassName={s.break}
        onPageChange={onPageChange}
        pageCount={totalPages}
        forcePage={currentPage}
        renderOnZeroPageCount={null}
        pageRangeDisplayed={innerWidth > 1024 ? 5 : 1}
        marginPagesDisplayed={innerWidth > 1024 ? 5 : 3}
      />
    </div>
  );
};
